<template>
  <div id="gHeader">
    <!-- ヘッダー部分 -->
    <header role="banner">
      <div class="headInr clearfix">
        <h1><a href="http://www.sonicmania.jp/2018/"><img src="https://firebasestorage.googleapis.com/v0/b/sonicmania-a78e6.appspot.com/o/header%2Fcmn_nav_logo.png?alt=media&token=90640224-e90d-42e5-9afc-d130c6e7eda3" alt="SONIC MANIA 2018" class="pcNone"></a></h1>
        <div class="navBtn pcNone" @click="clickNavBtn" v-bind:style="{display: menuVisible}"><img src="https://firebasestorage.googleapis.com/v0/b/sonicmania-a78e6.appspot.com/o/header%2Fcmn_nav_btn_sp.png?alt=media&token=998bbb05-a306-41d8-b9c7-b9d83a954008" alt="メニュー"></div>
      </div>
      <div class="sub-title copyPcNone">
        <p class="title">PDF版タイムテーブルは<a href="http://www.sonicmania.jp/2018/tt/">こちら</a></p>
      </div>
    </header>
    <nav id="nav" role="navigation" v-bind:class="{ 'open': menuOpen }">
      <ul id="gNav" class="clearfix">
        <li class="navLogo"><a href="http://www.sonicmania.jp/2018/"><img src="https://firebasestorage.googleapis.com/v0/b/sonicmania-a78e6.appspot.com/o/header%2Fcmn_nav_logo.png?alt=media&token=90640224-e90d-42e5-9afc-d130c6e7eda3" alt="SONIC MANIA 2018"></a></li>
        <li class="navClose" @click="clickNavClose">×</li>
        <li class="navCat"><a href="http://www.sonicmania.jp/2018/news/"><span>NEWS</span></a></li>
        <li class="navCat"><a href="http://www.sonicmania.jp/2018/lineup/"><span>ARTISTS</span></a></li>
        <li class="navCat"><a href="http://www.sonicmania.jp/2018/timetable/"><span>TIME TABLE</span></a>
          <div>
            <ul>
              <li><a href="http://www.sonicmania.jp/2018/timetable/">WEB版</a></li>
              <li><a href="http://www.sonicmania.jp/2018/tt/">PDF版</a></li>
            </ul>
          </div>
        </li>
        <li class="navCat"><a href="http://www.sonicmania.jp/2018/tickets/"><span>TICKETS</span></a></li>
        <li class="navCat"><a href="http://www.sonicmania.jp/2018/info/"><span>INFO</span></a>
          <div>
            <ul>
              <li><a href="http://www.sonicmania.jp/2018/info/">ACCESS</a></li>
              <li><a href="http://www.sonicmania.jp/2018/faq/">FAQ</a></li>
              <li><a href="http://www.sonicmania.jp/2018/info/attention.html">注意事項</a></li>
            </ul>
          </div>
        </li>
        <li class="navCat"><a href="http://www.sonicmania.jp/2018/thanks/"><span>SPONSORS</span></a></li>
        <li class="navCat"><a href="http://www.sonicmania.jp/2018/english/"><span>ENGLISH</span></a></li>
      </ul>
    </nav>
    <div class="sub-title spNone">
      <p class="title">PDF版タイムテーブルは<a href="http://www.sonicmania.jp/2018/tt/">こちら</a></p>
    </div>
    <!-- ヘッダー部分 -->
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      menuOpen: false,
      menuVisible: 'visible'
    }
  },
  methods: {
    clickNavBtn () {
      this.menuOpen = true
      this.menuVisible = 'none'
      this.$parent.position = 'fixed'
    },
    clickNavClose () {
      this.menuOpen = false
      this.menuVisible = 'visible'
      this.$parent.position = ''
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../../assets/css/components/parts/Header";
</style>



// WEBPACK FOOTER //
// src/components/parts/Header.vue